module.exports = __webpack_public_path__ + "static/img/paintnum.b832dc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/paintnum.png
// module id = XLr6
// module chunks = 1